<template>
  <div class="choose-box" ref="selectRoleInfo">
    <p class="switch-way">
      <span class="switch-way-content j-click-logout-account" @click="goLogOut">
        <span class="switch-way-content-ico"></span>
        {{ letter.logout }}
      </span>
      <span class="account">{{ letter.storeWelcome }}：{{ loginAccount }}</span>
    </p>
    <p
      class="pre-store-info"
      v-show="lastedGame == gameId && lastedServerId && getCurLastedServerName"
    >
      <span
      >{{ letter.previousSelect }}：{{ getCurLastedServerName }} -
        {{ lastedRoleName }}</span
      ><a class="again-role j-again-role" @click="setLastedServerId">{{
        letter.payAgainBtn
      }}</a>
    </p>
    <role-select></role-select>
    <div class="login-safe-check" v-if="isShowSafe">
      <template v-if="!isChecked">
        <div class="login-safe-spinning"></div>
        <span class="login-safe__text">
          {{ letter.safeChecking }}
        </span>
      </template>
      <template v-else>
        <div class="login-safe-success"></div>
        <span class="login-safe__text login-check-text">
          {{ letter.safeChecked }}
        </span>
      </template>

    </div>
  </div>
</template>

<script>
import RoleSelect from '@components/officialStore/login/RoleSelect.vue';
import login from '@mixins/officialStore/login';
import {mapState} from 'vuex';
import {clickButton} from '@plugins/biPoint/_configWebstoreV1';
import gameInfoConfig from "@configs/officialStore/globalGameInfoConfig";

export default {
  data:
    () => {
      return {
        isChecked: false
      }
    },
  mixins: [login],
  computed: {
    ...mapState({
      serverList: state => state.serverList,
      gameId: state => state.gameId,
      lastedRoleName: state => state.lastedRoleName,
      lastedServerId: state => state.lastedServerId,
      lastedRoleId: state => state.lastedRoleId,
      lastedGame: state => state.lastedGame,
      loginAccount: state => state.login.loginAccount,
    }),
    getCurLastedServerName() {
      let res = '';
      if (!this.serverList || this.lastedGame != this.gameId) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == this.lastedServerId) {
          res = this.serverList[i].NAME;
          break;
        }
      }
      return res;
    },
    isShowSafe() {
      return !!gameInfoConfig[this.gameId]?.isShowSafe;
    }
  },
  mounted() {
    let _self = this;
    window.addEventListener('scroll', function () {
      if (!_self.gameId) return;
      const top =
        _self.$refs.selectRoleInfo &&
        _self.$refs.selectRoleInfo.getBoundingClientRect() &&
        _self.$refs.selectRoleInfo.getBoundingClientRect().top;
      _self.$emit('updateShowTopRole', top < -400);
    });
    // 定时随机2-5秒后显示安全检测成功
    setTimeout(() => {
      this.isChecked = true;
    }, (Math.random() * 3000) + 2000);
  },
  methods: {
    setLastedServerId() {
      clickButton({
        btnName: 'store_again'
      });
      this.serverId = this.lastedServerId;
      this.roleId = this.lastedRoleId;
      this.loadRole('re_stored_bind');
    }
  },
  components: {
    RoleSelect
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';

.choose-box {
  margin: 0 auto;
  background-size: cover;
  @psetbg ('choose-box.png');
}

.switch-way {
  margin-bottom: 45px;
  text-align: left;
  font-size: 30px;
  color: var(--login-text);

  &-content {
    display: inline-block;
    margin-top: 66px;
    padding-left: 36px;
    cursor: pointer;
    text-align: left;
    font-size: 30px;
    color: var(--login-text);
  }

  &-content-ico {
    display: inline-block;
    top: 123px;
    margin-right: 15px;
    background-size: cover;
    cursor: pointer;
    @psetbg ('return.png');
  }

  .account {
    margin-left: 20px;
  }
}

.pre-store-info {
  position: relative;
  margin: 35px auto 35px;
  text-align: center;
  font-size: 20px;
  color: var(--login-text);

  .again-role {
    padding-left: 69px;
    text-decoration: underline;
    color: var(--login-restore);

    &:hover {
      cursor: pointer;
    }
  }
}

.ztmslg {
  .login-safe-check {
    margin: 40px auto !important;
  }
}

.login-safe-check {
  font-size: 22px;
  color: #ffea00;
  width: 542px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin: 100px auto;
  background: rgba(0,0,0,.8);
  border-radius: 10px;

  .login-safe-spinning {
    width: 27px;
    height: 26px;
    background-size: cover;
    animation: rotate 1s linear infinite;
    @psetbg ('login-safe-spinning.png')
  }

  .login-safe-success {
    width: 22px;
    height: 26px;
    background-size: cover;
    @psetbg ('login-safe-success.png')
  }
}

@media screen and (orientation: landscape) {
  .choose-box {
    // 这里
    position: relative;
    @psetbg ('choose-box-hen.png');
  }
  .back-select-login {
    left: 296px;
  }
  .login-safe-check {
    font-size: 18px;
  }
}
</style>
